"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardContextTypes = exports.ContextConfiguration = exports.NothingContextKey = exports.ValuationContextKey = exports.TimeRangeContextKey = exports.PositionContextKey = exports.PortfolioContextKey = exports.OrganizationContextKey = exports.InstrumentListContextKey = exports.InstrumentContextKey = exports.EmailContextKey = exports.CurrencyContextKey = exports.CountryContextKey = exports.ContactListContextKey = exports.ContactContextKey = exports.ChatInitSettingsContextKey = exports.ChartContextKey = void 0;
exports.ChartContextKey = 'fdc3.chart';
exports.ChatInitSettingsContextKey = 'fdc3.chat.initSettings';
exports.ContactContextKey = 'fdc3.contact';
exports.ContactListContextKey = 'fdc3.contactList';
exports.CountryContextKey = 'fdc3.country';
exports.CurrencyContextKey = 'fdc3.currency';
exports.EmailContextKey = 'fdc3.email';
exports.InstrumentContextKey = 'fdc3.instrument';
exports.InstrumentListContextKey = 'fdc3.instrumentList';
exports.OrganizationContextKey = 'fdc3.organization';
exports.PortfolioContextKey = 'fdc3.portfolio';
exports.PositionContextKey = 'fdc3.position';
exports.TimeRangeContextKey = 'fdc3.timerange';
exports.ValuationContextKey = 'fdc3.valuation';
exports.NothingContextKey = 'fdc3.nothing';
exports.ContextConfiguration = {
    [exports.ChartContextKey]: {
        label: 'Chart',
        icon: 'pie-chart',
    },
    [exports.ChatInitSettingsContextKey]: {
        label: 'ChatInitSettings',
        icon: 'chat',
    },
    [exports.ContactContextKey]: {
        label: 'Contact',
        icon: 'badge',
    },
    [exports.ContactListContextKey]: {
        label: 'ContactList',
        icon: 'badge',
    },
    [exports.CountryContextKey]: {
        label: 'Country',
        icon: 'flag',
    },
    [exports.CurrencyContextKey]: {
        label: 'Currency',
        icon: 'dollar',
    },
    [exports.EmailContextKey]: {
        label: 'Email',
        icon: 'mail',
    },
    [exports.InstrumentContextKey]: {
        label: 'Instrument',
        icon: 'money',
    },
    [exports.InstrumentListContextKey]: {
        label: 'InstrumentList',
        icon: 'money',
    },
    [exports.OrganizationContextKey]: {
        label: 'Organization',
        icon: 'organisation',
    },
    [exports.PortfolioContextKey]: {
        label: 'Portfolio',
        icon: 'building',
    },
    [exports.PositionContextKey]: {
        label: 'Position',
        icon: 'building',
    },
    [exports.TimeRangeContextKey]: {
        label: 'TimeRange',
        icon: 'date-range',
    },
    [exports.ValuationContextKey]: {
        label: 'Valuation',
        icon: 'equation',
    },
    [exports.NothingContextKey]: {
        label: 'Nothing',
        icon: 'fdc3',
    },
};
exports.StandardContextTypes = Object.keys(exports.ContextConfiguration);
